import api from '@/api/v2';
export var FileVisibility;
(function (FileVisibility) {
    FileVisibility["Public"] = "public";
    FileVisibility["SurveyAnswer"] = "survey-answer";
})(FileVisibility || (FileVisibility = {}));
export var FileType;
(function (FileType) {
    FileType["MULTIMEDIA"] = "multimedia";
    FileType["DOCUMENT"] = "document";
})(FileType || (FileType = {}));
export const createFileUpload = async (dto) => {
    const { data } = await api.post('/files', dto);
    return data;
};
export const confirmFileUpload = async (fileId) => {
    const { data } = await api.post(`/files/confirm/${fileId}`, {});
    return data;
};
export const normalizeFileName = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 ||
        lastDotIndex === 0 ||
        lastDotIndex === fileName.length - 1) {
        return fileName;
    }
    const name = fileName.slice(0, lastDotIndex);
    const extension = fileName.slice(lastDotIndex + 1);
    if (!extension.trim()) {
        return fileName;
    }
    return `${name}.${extension.toLowerCase()}`;
};
export const uploadFileToS3 = async (fileData, uploadHandle) => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(uploadHandle.fields)) {
        formData.append(key, value);
    }
    formData.append('file', fileData);
    const response = await fetch(uploadHandle.url, {
        method: 'POST',
        body: formData,
    });
    if (!response.ok) {
        throw new Error(await response.text());
    }
    return {
        url: `${process.env.VUE_APP_CDN_V2_URL}${uploadHandle.fields.key}`,
        key: uploadHandle.fields.key,
        id: uploadHandle.fileId,
    };
};
export const getObjectAttachmentList = async (params) => {
    const { data } = await api.get('/files', {
        params,
    });
    return data;
};
